"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadowTextCursorPosition = void 0;

var _diff = require("diff");

/**
 * @param {string} shadowText
 * @param {string} text
 * @param {number} textCursorPosition
 * @returns {number}
 */
var getShadowTextCursorPosition = function getShadowTextCursorPosition(shadowText, text, textCursorPosition) {
  var textFirstPart = text.substring(0, textCursorPosition);
  var diffList = (0, _diff.diffWords)(shadowText, textFirstPart);
  var i = 0;
  var shadowTextFirstPartLength = 0;

  while (i < diffList.length) {
    var _diffList$i = diffList[i],
        value = _diffList$i.value,
        removed = _diffList$i.removed;
    var isNotLast = !!diffList[i + 1];
    var skipNext = removed && isNotLast;

    if (!removed || skipNext) {
      shadowTextFirstPartLength += value.length;
    }

    i += skipNext ? 2 : 1;
  }

  return shadowTextFirstPartLength;
};

exports.getShadowTextCursorPosition = getShadowTextCursorPosition;